export default "__VITE_ASSET__DBoLORFs__"